<div>
  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{label}}</div>
    <ng-content></ng-content>
    <div class="p-1 w-75">
      <input class="form-control form-select-sm" (click)="pickerVisible = !pickerVisible" (change)="inputChanged()" [ngStyle]="colorPickerStyle()"
        [ngModelOptions]="{standalone: true}" [(ngModel)]="symbolizer[attribute]" />
    </div>
  </div>
  <!-- TODO: Remove function call from template -->
  <color-sketch [color]="hsColorPickerService.addAlpha(symbolizer[attribute], symbolizer[opacityAttribute])"
  width="320px"
    *ngIf="pickerVisible && symbolizer[attribute] !== undefined" (onChangeComplete)="onPick($event)"></color-sketch>
  <color-sketch *ngIf="pickerVisible && symbolizer[attribute] === undefined" width="320px" (onChangeComplete)="onPick($event)">
  </color-sketch>
</div>